import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { DepartmentApiService } from 'src/api/department'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createDepartment, createDepartmentFailure, createDepartmentSuccess, loadDepartments, loadDepartmentsFailure, loadDepartmentsSuccess, updateDepartment, updateDepartmentFailure, updateDepartmentSuccess } from './department.actions'


@Injectable()
export class DepartmentEffects {
  private actions$ = inject(Actions)
  private DepartmentApi = inject(DepartmentApiService)
  private toaster = inject(ToasterService)


  loadDepartments$ = createEffect(() => this.actions$.pipe(
    ofType(loadDepartments),
    switchMap(() =>
      from(this.DepartmentApi.list({ limit: Number.MAX_SAFE_INTEGER })).pipe(
        map(r => loadDepartmentsSuccess({
          departments: r.data,
        })),
        catchAndLog(this.toaster, 'Unable to fetch departments', loadDepartmentsFailure
      )))))

  createDepartment$ = createEffect(() => this.actions$.pipe(
    ofType(createDepartment),
    tap(() => this.toaster.progress('Creating department...')),
    switchMap(action =>
      from(this.DepartmentApi.create(action.department)).pipe(
        map(res => createDepartmentSuccess({ department: res.data })),
        tap(() => this.toaster.success('Department created successfully.')),
        catchAndLog(this.toaster, 'Unable to create department', createDepartmentFailure
      )))))

  updateDepartment$ = createEffect(() => this.actions$.pipe(
    ofType(updateDepartment),
    tap(() => this.toaster.progress('Updating department...')),
    switchMap(action =>
      from(this.DepartmentApi.update(action.id, action.department)).pipe(
        map(res => updateDepartmentSuccess({ department: res.data })),
        tap(() => this.toaster.success('Department updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update department', updateDepartmentFailure
      )))))
}
